import styled from "styled-components";

export const StyledContainer = styled.section`
 width: 100%;
 margin: 80px 0 100px 0;
`

export const CardsWrapper = styled.section`
    margin-top: 40px;
`